import React, { useEffect, useState } from "react";
import cn from "classnames";

import Button from "../element/Button";
import { testMandatoriesFns } from "../test-mandatories";

import "./stepper-buttons.scss";
import { useSelector } from "react-redux";

const StepperButtons = ({
  nextStep,
  prevStep,
  currentStep,
  localState,
  isSumsubForm,
}) => {
  const firstComponent = isSumsubForm
    ? currentStep?.id === "sumsub-id-verification"
    : currentStep?.id === "about-you";
  const lastComponent = currentStep?.id === "review-and-agreement";
  const noButton = currentStep?.name === "Account Setup";
  const noPrevButton = isSumsubForm
    ? currentStep?.id === "business-deal"
    : currentStep?.id === "about-you";

  const { existingRequests } = useSelector((state) => state.profile);

  // Add class based on number of buttons
  const buttonsBlockStyle = cn({
    "footer-buttons": true,
    "single-button": firstComponent || noPrevButton,
  });

  const [disabledButton, setDisabledButton] = useState(true);

  useEffect(() => {
    // check for agreement
    switch (currentStep?.id) {
      case "about-you":
        if (testMandatoriesFns.aboutYou(localState.profile)) {
          setDisabledButton(false);
        } else {
          setDisabledButton(true);
        }
        break;
      case "id-verification":
        if (
          testMandatoriesFns.IDVerification(
            localState.profile,
            localState.files
          )
        ) {
          setDisabledButton(false);
        } else {
          setDisabledButton(true);
        }
        break;
      case "sumsub-id-verification":
        if (localState.sumsubDocsAreVerified) {
          setDisabledButton(false);
        } else {
          setDisabledButton(true);
        }
        break;
      case "business-deal":
        if (
          testMandatoriesFns.businessDeal(localState.profile, localState.limits)
        ) {
          setDisabledButton(false);
        } else {
          setDisabledButton(true);
        }
        break;
      case "review-and-agreement":
        if (
          testMandatoriesFns.agreement(localState) &&
          !testMandatoriesFns.hasOpenInquiries(existingRequests)
        ) {
          setDisabledButton(false);
        } else {
          setDisabledButton(true);
        }
        break;

      default:
        setDisabledButton(true);
        break;
    }
  }, [currentStep, localState, existingRequests]);

  if (!noButton)
    return (
      <div className="footer-wrapper">
        <div className={buttonsBlockStyle}>
          {!firstComponent && !noPrevButton && (
            <Button
              id="step-button-previous"
              onClick={prevStep}
              className="main-button prev-button"
            >
              Previous
            </Button>
          )}
          <div className="next-button-wrapper">
            <Button
              id="step-button-next-submit"
              disabled={disabledButton}
              className={cn({
                "submit-app-btn": lastComponent,
              })}
              onClick={nextStep}
            >
              {lastComponent ? "Submit Application" : "Next step"}
            </Button>
            {testMandatoriesFns.hasOpenInquiries(existingRequests) &&
              lastComponent && (
                <span className="pending-correction">
                  Pending personal data correction
                </span>
              )}
          </div>
        </div>
      </div>
    );
  return null;
};

export default StepperButtons;
